import React, {useState} from 'react';
import {Link} from "react-router-dom";
import { LuSoup } from "react-icons/lu";
import { FaPizzaSlice } from "react-icons/fa";
import { GiWineBottle } from "react-icons/gi";
import { CiCoffeeCup } from "react-icons/ci";
import { FaBars } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import {AnimatePresence, motion} from 'framer-motion';

const Navigator = ({isMainMenu = true, isAlcohol = true, isDrinks = true, isFastFood = true}) => {
    const [isOpened, setIsOpened] = useState(false);

    return (
        <div className={'fixed bottom-1 left-1/2 -translate-x-1/2 flex flex-col gap-2 items-center justify-evenly z-10'}>
            <AnimatePresence initial={true} mode={'wait'}>
            {
                isOpened
                &&
                <div className={'flex flex-col gap-3'}>
                    {
                        isMainMenu
                        &&
                        <motion.button
                            key={'main'}
                            initial={{
                                y: '10px',
                                opacity: 0,
                            }}
                            animate={{
                                y: '0px',
                                opacity: 1,
                                transition: {
                                    delay: 0.2,
                                    duration: 0.5,
                                }
                            }}
                            exit={{
                                y: '10px',
                                opacity: 0,
                                transition: {
                                    delay: 0.2,
                                    duration: 0.5,
                                }
                            }}
                            className={'w-16 h-16'}>
                        <Link to={'/main-menu'} className={'w-full h-full text-5xl flex justify-center items-center rounded-full bg-white border border-red-500 px-4 py-2 text-center'}>
                            <LuSoup/>
                        </Link>
                        </motion.button>
                    }
                    {
                        isFastFood
                        &&
                        <motion.button
                            key={'fastfood'}
                            initial={{
                                y: '10px',
                                opacity: 0,
                            }}
                            animate={{
                                y: '0px',
                                opacity: 1,
                                transition: {
                                    delay: 0.15,
                                    duration: 0.5,
                                }
                            }}
                            exit={{
                                y: '10px',
                                opacity: 0,
                                transition: {
                                    delay: 0.15,
                                    duration: 0.5,
                                }
                            }}
                            className={'w-16 h-16'}>
                        <Link to={'/fastfood'} className={'w-full h-full text-5xl flex justify-center items-center rounded-full bg-white border border-red-500 px-4 py-2 text-center'}>
                            <FaPizzaSlice/>
                        </Link>
                        </motion.button>
                    }
                    {
                        isAlcohol
                        &&
                        <motion.button
                            key={'alcohol'}
                            initial={{
                                y: '10px',
                                opacity: 0,
                            }}
                            animate={{
                                y: '0px',
                                opacity: 1,
                                transition: {
                                    delay: 0.1,
                                    duration: 0.5,
                                }
                            }}
                            exit={{
                                y: '10px',
                                opacity: 0,
                                transition: {
                                    delay: 0.1,
                                    duration: 0.5,
                                }
                            }}
                            className={'w-16 h-16'}>
                        <Link to={'/alcohol'} className={'w-full h-full text-5xl flex justify-center items-center rounded-full bg-white border border-red-500 px-4 py-2 text-center'}>
                            <GiWineBottle/>
                        </Link>
                        </motion.button>
                    }
                    {
                        isDrinks
                        &&
                        <motion.button
                            key={'drinks'}
                            initial={{
                                y: '10px',
                                opacity: 0,
                            }}
                            animate={{
                                y: '0px',
                                opacity: 1,
                                transition: {
                                    delay: 0.05,
                                    duration: 0.5,
                                }
                            }}
                            exit={{
                                y: '10px',
                                opacity: 0,
                                transition: {
                                    delay: 0.05,
                                    duration: 0.5,
                                }
                            }}
                            className={'w-16 h-16'}>
                        <Link to={'/drinks'} className={'w-full h-full text-5xl flex justify-center items-center rounded-full bg-white border border-red-500 px-4 py-2 text-center'}>
                            <CiCoffeeCup/>
                        </Link>
                        </motion.button>
                    }
                </div>
            }
            </AnimatePresence>

            <button onClick={() => setIsOpened(!isOpened)} className={`text-5xl transition duration-500 rounded-full flex justify-center items-center border border-red-500  w-16 h-16 ${isOpened ? ' text-white bg-red-600 ' : ' text-black bg-white'}`}>{isOpened ? <IoMdClose/> : <FaBars/>}</button>
        </div>
    );
};

export default Navigator;